import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ChatCoreModule } from '../chat-core.module';
import { ChatLauncherComponent } from './chat-launcher.component';

/** O balão flutuante do chat, montado no layout do CRM (todas as páginas). */
@NgModule({
  declarations: [ChatLauncherComponent],
  imports: [CommonModule, RouterModule, NgbTooltipModule, ChatCoreModule],
  exports: [ChatLauncherComponent]
})
export class ChatLauncherModule { }
